module.exports = __webpack_public_path__ + "static/02-7c1a00b2df3d3f18d98b1b7e6db515b8.jpg";